import { IconSvg } from 'Components/shared/Icon/index.generated';
import { UserAvatar } from 'Components/shared/UserAvatar';
import { MobXProviderContext, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { Button } from '~/lib/ui/button';
import { AVATAR_CONFIG } from '../../../../utils/avatar_dimensions';
import EntityBasicInfo from '../../../EntityBasicInfo';
import { GroupDetailsHeaderProps } from './index.types';

const { size, fontSize } = AVATAR_CONFIG.HEADER_DIMENSIONS;

export const GroupDetailsHeader = observer(
  ({ conversation, closePanel }: GroupDetailsHeaderProps) => {
    const { conversation: conversationStore, person: personStore } =
      useContext<RootStoreProps>(MobXProviderContext);

    const groupName = () => {
      if (!conversation) return '';

      if (conversation.grouping === 'Group') {
        return conversationStore.createProperName(
          conversation?.participants?.filter(
            (participant) =>
              participant.personId !== personStore.loggedInPersonId
          )
        );
      }

      if (conversation.grouping === 'Channel') {
        return conversation.topic;
      }

      return '';
    };

    const conversationGrouping = () => {
      if (conversation.participants.length > 2) {
        const otherParticipants = conversation.participants.filter(
          (participant) => participant.personId !== personStore.loggedInPersonId
        );

        return otherParticipants.some((participant) => participant.personId)
          ? 'Channel'
          : 'Group';
      }

      return conversation.grouping;
    };

    return (
      <>
        <div className="flex items-end justify-end">
          <Button
            variant="ghost"
            size="icon"
            className="p-0 hover:bg-transparent"
            onClick={closePanel}
          >
            {IconSvg['cross']}
          </Button>
        </div>

        <div className="flex items-center justify-center">
          <UserAvatar
            size={size}
            fontSize={fontSize}
            iconSize={AVATAR_CONFIG.getIconSize(size)}
            conversationId={conversation?.id}
            conversationGrouping={conversationGrouping()}
            key={`group-details-avatar-${conversation?.id}`}
          />
        </div>

        <EntityBasicInfo
          name={groupName()}
          description={conversation?.description}
        />
      </>
    );
  }
);
